// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mfFk","content":"styles_content__1msyv"};